/* GENERATED from src/js/ndog-warranty-badge.js — edit the source, then run `make js`. Never edit this file by hand. */
/* <ndog-warranty-badge> — footer pill button that opens a native <dialog>
   with the official EU legal-guarantee graphic (snippets/ndog-warranty-badge.liquid).
   Escape, focus trap and focus restore come from the browser's <dialog>;
   this component only wires open/close, backdrop click and the scroll lock. */
if (!customElements.get('ndog-warranty-badge')) {
  customElements.define(
    'ndog-warranty-badge',
    class NdogWarrantyBadge extends HTMLElement {
      // Binds the button, the dialog and its close controls.
      connectedCallback() {
        this.button = this.querySelector('[data-warranty-open]');
        this.dialog = this.querySelector('dialog');
        if (!this.button || !this.dialog || typeof this.dialog.showModal !== 'function') return;

        this.onOpen = () => this.open();
        this.onClose = () => this.close();
        this.onBackdrop = (event) => this.handleBackdrop(event);
        this.onClosed = () => this.handleClosed();

        this.button.addEventListener('click', this.onOpen);
        this.dialog.addEventListener('click', this.onBackdrop);
        this.dialog.addEventListener('close', this.onClosed);
        this.closeButtons = Array.from(this.dialog.querySelectorAll('[data-warranty-close]'));
        this.closeButtons.forEach((el) => el.addEventListener('click', this.onClose));
      }

      // Removes all listeners so nothing leaks when the footer is re-rendered (theme editor).
      disconnectedCallback() {
        if (!this.button || !this.dialog) return;
        this.button.removeEventListener('click', this.onOpen);
        this.dialog.removeEventListener('click', this.onBackdrop);
        this.dialog.removeEventListener('close', this.onClosed);
        this.closeButtons.forEach((el) => el.removeEventListener('click', this.onClose));
        this.handleClosed();
      }

      // Opens the modal and locks page scroll.
      open() {
        if (this.dialog.open) return;
        this.dialog.showModal();
        document.documentElement.classList.add('ndog-warranty-open');
      }

      // Closes the modal (the 'close' event releases the scroll lock).
      close() {
        if (this.dialog.open) this.dialog.close();
      }

      // A click on the ::backdrop targets the <dialog> itself — the inner panel fills the dialog completely.
      handleBackdrop(event) {
        if (event.target === this.dialog) this.close();
      }

      // Releases the scroll lock after any close (button, backdrop, Escape).
      handleClosed() {
        document.documentElement.classList.remove('ndog-warranty-open');
      }
    },
  );
}
